import { render, staticRenderFns } from "./Dashboard.component.html?vue&type=template&id=adf263f6&scoped=true&"
import script from "./Dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./Dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./Dashboard.component.scss?vue&type=style&index=0&id=adf263f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf263f6",
  null
  
)

export default component.exports